import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UserService } from '@src/core/services';

@Component({
  selector: 'app-association',
  templateUrl: './association.component.html',
  styleUrls: ['./association.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssociationComponent implements OnInit {
  private readonly userService = inject(UserService);

  parentOrganisationId?: string;

  ngOnInit(): void {
    this.parentOrganisationId = this.userService.authUser$.value?.parentOrganisationId;
  }
}
